"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "m8 7.5 4 4 4-4V4H8z",
  opacity: ".3"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "m8 7.5 4 4 4-4V4H8z",
  opacity: ".3"
}, "1"), /*#__PURE__*/_jsx("path", {
  d: "M18 2H6v6l4 4-3.99 4.01L6 22h12l-.01-5.99L14 12l4-3.99zm-2 14.5V20H8v-3.5l4-4zm0-9-4 4-4-4V4h8z"
}, "2")], 'HourglassTopTwoTone');